import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Permissions from '../../interfaces/permissions';

interface PermissionsState {
    permissions: Permissions[],
}

const initialState: PermissionsState = {
    permissions: []
}

export const permissionsSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        loadPermissions: (state, action: PayloadAction<Permissions[]>) => {
            state.permissions = action.payload;
        }
    }
});

export const { loadPermissions } = permissionsSlice.actions;

export default permissionsSlice.reducer;